export enum SignalType {
	PinkNoise = 'PINK_NOISE',
	WhiteNoise = 'WHITE_NOISE',
	SineWave = 'SINE_WAVE',
	Sweep = 'SWEEP'
}
